module.exports = __webpack_public_path__ + "static/img/zyjb.c214838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/components/img/zyjb.jpg
// module id = ThFR
// module chunks = 1